import * as React from 'react'
import { FC, FormEvent, useEffect, useRef } from 'react'
import { navigate } from 'gatsby'
import SvgIcon from '../../../components/SVGIcon/SvgIcon'
import { tagUrlify } from '../../../utils/utils'
import { ISearch } from './Search.types'
import * as styles from './Search.module.scss'

const SearchBar: FC<ISearch> = ({ searchQuery, setSearchQuery, selectedTag }) => {

  const inputElement = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputElement.current && searchQuery) {
      (inputElement.current).focus();
    }
  }, []);

  const changePage = (currentQuery?: string) => {
    if (selectedTag) {
      void navigate(`/tags/${tagUrlify(selectedTag)}/?search=${currentQuery || ''}`)
    } else {
      void navigate(`/tags/company-search/?search=${currentQuery || ''}`)
    }
  }

  const onChange = (e: FormEvent<HTMLInputElement>) => {
    setSearchQuery((e.target as HTMLInputElement).value);
    changePage((e.target as HTMLInputElement).value);
  }

  return (
    <div className={styles.form}>
      <input
        value={searchQuery}
        onChange={onChange}
        type="text"
        placeholder="Search"
        className={styles.search}
        ref={inputElement}
      />
      <div className={styles.button}>
        <SvgIcon href="/images/search.svg#icon" className={styles.icon} />
      </div>
    </div>
  )
}

export default SearchBar
